<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-snowsquall`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M36.556 16.122C34.8 8.602 28.055 3 20 3 10.611 3 3 10.611 3 20c0 6.497 3.644 12.142 9 15.004v-4.756C8.956 27.868 7 24.163 7 20c0-7.18 5.82-13 13-13s13 5.82 13 13h2l.225.004A6 6 0 0138 31.197v4.345c4.058-1.275 7-5.065 7-9.542 0-4.994-3.66-9.133-8.444-9.878zM17 30a3 3 0 110 6 3 3 0 010-6zm-5 11a3 3 0 10-6 0 3 3 0 006 0zm5-3a3 3 0 110 6 3 3 0 010-6zm8 0a3 3 0 110 6 3 3 0 010-6zm3-5a3 3 0 10-6 0 3 3 0 006 0zm5-3a3 3 0 110 6 3 3 0 010-6z"/></svg>
</template>
<script>

export default {
  name: 'IconSnowsquall',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
